import React from "react";
import "./NewCardComponent.scss";
import Button from "../../Common/Button/Button";
const NewCardComponent = (props) => {
  const handleButtonClick = () => {
    window.open(props?.url);
  };

  return (
    <div className="new-card-container">
      <div className="new-card-img-div">
        <img className="new-card-img" src={props?.cardImage} alt="" />

        <div className="new-card-text-btn">
          <div className="new-card-txt">{props?.text}</div>
          {props?.btnName !== null && (
            <Button name={props?.btnName} onClick={() => handleButtonClick()} />
          )}
        </div>
      </div>
    </div>
  );
};

export default NewCardComponent;
